import { Gtag } from "configs/ReactGa";

interface ReactGaProps {
  eventName: string;
  eventParams: object;
}

export function ReactGa(props: ReactGaProps) {
  Gtag("event", props.eventName, props.eventParams);
  return <></>;
}
